import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({name: 'dateTime'})
export class DateTimePipe implements PipeTransform {
    transform(dateTime: string): string {
        return formatDate(dateTime, 'yyyy-MM-dd HH:mm', 'se-SE');
    }
}
